
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talking-sense",
      function () {
        return require("private-next-pages/talking-sense/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talking-sense"])
      });
    }
  